import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";

import CoinChart from "./Coin/CoinChart";
import QuickTrade from "./Coin/QuickTrade";
import CoinBuyTable from "./Coin/CoinBuyTable";
import CoinSellTable from "./Coin/CoinSellTable";
import { getCoinById } from "../../../api/coin";
import { Dropdown } from "react-bootstrap";
import { getCoinPricesByCoinId } from "../../../api/coinPrice";
import Trade from "../Admin/CommanPage/trade";



const CoinDetails = () => {
  const { coinId } = useParams();
  const [coin, setCoin] = useState(null);
  const [refreshTables, setRefreshTables] = useState(false);
  // console.log("COIN", coin)
  useEffect(() => {
    const getCoindatabyId = async () => {
      const data = await getCoinById(coinId);
      setCoin(data);
    };

    getCoindatabyId();
  }, [coinId]);
  // console.log("COIN MUID", coinId)

  const handleTradeSuccess = () => {
    setRefreshTables((prev) => !prev); // toggle true/false to trigger useEffect in children
  };

  if (!coin) return <div>Loading...</div>;
  return (
    <div className="">
      <div className="row">
  <div className="col-xl-9 col-xxl-9 order-2 order-xl-1">
    <CoinChart coin={coin} />
  </div>

  <div className="col-xl-3 col-xxl-3 col-sm-12 order-1 order-xl-2">
    <div className="card digital-cash">
      <div className="card-header border-0">
        <h4 className="mb-0 heading">About</h4>
      </div>
      <div className="card-body py-0">
        <div className="text-center">
          <div className="media d-block">
            {coin.logo ? (
              <img
                src={`${process.env.REACT_APP_API_BASE_URL}/uploads/${coin.logo}`}
                alt={coin.symbol}
                width="126"
                height="126"
                style={{ marginBottom: "15px", borderRadius: "50%" }}
              />
            ) : (
              <svg
                width="126"
                height="126"
                viewBox="0 0 126 126"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="63" cy="63" r="63" fill="#3693FF" />
              </svg>
            )}
            <div className="media-content">
              <h4 className="mt-3 fs-20 font-w700 text-black mb-0">
                {coin.name}
              </h4>
              <span className="font-w600 text-black">{coin.symbol}</span>
              <span className="my-3 fs-16 font-w600 d-block">
                1 {coin.symbol} = {coin.price} USD
              </span>
              <p
                className="text-start"
                dangerouslySetInnerHTML={{ __html: coin.description }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

      <div className="d-flex row">
        <div className="col-xl-6 col-sm-12">
          {/* <QuickTrade coin={coin} onTradeSuccess={handleTradeSuccess} /> */}
          <Trade coin={coin} onTradeSuccess={handleTradeSuccess} />
        </div>
        <div className="col-xl-3 col-sm-12">
          <CoinBuyTable
            coinId={coinId}
            bgChange="secondary"
            refresh={refreshTables}
          />
        </div>
        <div className="col-xl-3 col-sm-12">
          <CoinSellTable
            coinId={coinId}
            bgChangeSell="secondary"
            refresh={refreshTables}
          />
        </div>
      </div>
    </div>
  );
};

export default CoinDetails;
